<template>
  <transition name="fade">
    <div class="flying" v-show="show">
      <img src="~@/assets/imgs/loading/cloud2.png" class="flying__cloud2" :class="{ move }">
      <img src="~@/assets/imgs/loading/o0.png" class="flying__flower" :class="{ move }">
      <img src="~@/assets/imgs/loading/cloud1.png" class="flying__cloud3" :class="{ move }">
      <img src="~@/assets/imgs/loading/cloud1.png" class="flying__cloud1" :class="{ move }">
    </div>
  </transition>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      move: false
    }
  },

  methods: {
    hide () {
      this.show = true
      setTimeout(() => {
        this.move = true
      }, 300)
      setTimeout(() => {
        this.$emit('hide')
        setTimeout(() => {
          this.show = false
        }, 2200)
      }, 6000)
    }
  }
}
</script>

<style lang="scss">
@import '../style/mixin.scss';
@import '../style/color.scss';

@keyframes flyingMove {
  0% {
    transform: translate(-100%, -20%) rotate(30deg);
  }
  20% {
    transform: translate(100%, 0%) rotate(60deg);
  }
  80% {
    opacity: 1;
    transform: translate(-150%, 300%) rotate(170deg);
  }
  100% {
    opacity: 0;
    transform: translate(0%, 0%) rotate(420deg);
  }
}

.flying {
  @include fullfill;
  z-index: 100;
  &__flower {
    position: absolute;
    width: 8.1vw;
    transform: translate(-100%, -20%) rotate(60deg);
    left: 70%;
    top: 30%;
    &.move {
      animation-name: flyingMove;
      animation-duration: 7s;
      animation-fill-mode: forwards;
      animation-timing-function: linear;
    }
  }
  &__cloud2 {
    position: absolute;
    top: 0%;
    left: 100%;
    width: 80%;
    transition: transform linear 6s;
    &.move {
      transform: translate(-180vw, -20vh);
    }
  }
  &__cloud3 {
    position: absolute;
    top: 10%;
    left: 100%;
    width: 200%;
    transition: transform linear 4.5s;
    &.move {
      transform: translate(-300vw, -20vh);
    }
  }
  &__cloud1 {
    position: absolute;
    top: 30%;
    left: 100%;
    width: 400%;
    transition: transform linear 3s;
    &.move {
      transform: translate(-500vw, -20vh);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Flying.vue